



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CirculationSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    nadi_frekuensi: null,
    nadi_kekuatan: "kuat",
    nadi_irama: "reguler",
    td_sistolik: null,
    td_diastolik: null,
    map: null,
    suhu: null,
    crt: "kurang_3",
    urine_jumlah: null,
    urine_warna: ""
  };

  get mapKritis(): boolean {
    return typeof this.form.map === "number" && this.form.map > 0 && this.form.map < 65;
  }

  @Watch("form.td_sistolik")
  onSys() { this.recalcMap(); }

  @Watch("form.td_diastolik")
  onDia() { this.recalcMap(); }

  recalcMap() {
    const s = Number(this.form.td_sistolik);
    const d = Number(this.form.td_diastolik);
    if (Number.isFinite(s) && Number.isFinite(d) && s > 0 && d > 0) {
      this.form.map = Math.round((s + 2 * d) / 3);
    } else {
      this.form.map = null;
    }
  }

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    this.recalcMap();
  }
}
